import { Form, Formik } from 'formik';
import { Props, Values } from './CompanyBankAccount.types';
import * as Yup from 'yup';
import FormField from '../../components/field/FormField';
import Button from '../../components/button/Button';
import { useTranslation } from '../../context/translationContext';

export const CompanyBankAccountForm = ({ onSubmit, initialValues, onBack }: Props) => {
  const { t } = useTranslation();
  const _initialValues: Values = {
    name: '',
    number: '',
    iban: '',
    swift: '',
  };

  const CompanySchema = Yup.object().shape({
    name: Yup.string().required('Company name is required.'),
    number: Yup.string().required('Account number is required.'),
  });

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues || _initialValues}
      onSubmit={onSubmit}
      validationSchema={CompanySchema}
    >
      {({ errors, touched }) => (
        <Form className="w-full text-center">
          <div className="my-4">
            <FormField
              id="name"
              name="name"
              label={t('page.bank-account.col-name')}
              errors={errors}
              touched={touched}
            />
          </div>
          <div className="my-4">
            <FormField
              id="number"
              name="number"
              label={t('page.bank-account.col-number')}
              errors={errors}
              touched={touched}
            />
          </div>
          <div className="my-4">
            <FormField
              id="iban"
              name="iban"
              label={t('page.bank-account.col-iban')}
              errors={errors}
              touched={touched}
            />
          </div>
          <div className="my-4">
            <FormField
              id="swift"
              name="swift"
              label={t('page.bank-account.col-swift')}
              errors={errors}
              touched={touched}
            />
          </div>
          <div className="flex float-left">
            <Button title={t('general.back')} color="gray" className="mr-3" onClick={onBack} />
            <Button title={t('general.save')} color="green" type="submit" showLoading />
          </div>
        </Form>
      )}
    </Formik>
  );
};
